var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 68,
    viewBox: "0 0 76 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 68,
    fill: "#3678f7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.606,26.641,17.7,23.954l-.03-17.332a2.789,2.789,0,0,0-2.958-2.97,2.8,2.8,0,0,0-2.965,2.97V27.169c0,1,1.21,1.858,3.374,2.283L27.987,32.29c1.737.178,3.083-.246,3.519-2.316.46-2.141-.987-2.9-2.9-3.333",
    transform: "translate(27.957 8.643)",
    fill: "#3678f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.858,0A34.132,34.132,0,0,0,8,29.743l-7.6-.02c-.45.118-.541.478-.176.791L10.708,42.867c.355.3.619.128.977-.276l9.722-12.222c.139-.455-.115-.71-.565-.586l-7.569-.024a.1.1,0,0,1,.02-.047,28.854,28.854,0,1,1,8.353,24.827c-1.1,1.451-2.228,2.764-3.255,4.121A34.058,34.058,0,1,0,41.858,0",
    transform: "translate(0.001 -0.001)",
    fill: "#3678f7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYear);
export default __webpack_public_path__ + "static/media/year.6b91a539bab0a39c6ac0b97f5269aaed.svg";
export { ForwardRef as ReactComponent };